/**
 * Auðkenni Verification - Frontend JavaScript
 * 
 * Handles the verification flow in the Shopify storefront
 */

(function() {
  'use strict';

  // Configuration – app backend URL (tunnel when using shopify app dev, or Vercel when deployed)
  const API_BASE = window.__AUDKENNI_APP_URL__ || 'https://innskraning.islandshus.is';
  
  const POLL_INTERVAL = 5000; // 5 seconds
  const MAX_POLL_ATTEMPTS = 60; // 5 minutes max

  // State
  let currentSessionId = null;
  let emailFormSessionId = null;
  let pollInterval = null;
  let pollAttempts = 0;
  let errorRetryCount = 0;
  let pendingCompleteData = null;
  // Inline registration (collect email on invite page without leaving)
  let registrationToken = null;
  let registrationReturnTo = '/account';

  // DOM Elements
  const container = document.getElementById('audkenni-verify');
  if (!container) return;

  const customerId = container.dataset.customerId || 'guest';
  const shop = container.dataset.shop;
  if (!shop) return;
  const requireCheckout = container.dataset.requireCheckout === 'true';
  const loginMode = container.dataset.loginMode || '';
  const accountLoginUrl = container.dataset.accountLoginUrl || '/account/login';
  const embedAccountLogin = container.dataset.embedAccountLogin === 'true';
  const loginReturnPath = container.dataset.loginReturnPath || '/account';
  const locale = window.__AUDKENNI_LOCALE__ || {};
  const supportUrl = window.__AUDKENNI_SUPPORT_URL__ || '';
  const methodInputs = container.querySelectorAll('input[name="auth-method"]');
  const simInputGroup = document.getElementById('sim-input');
  const ktInputGroup = document.getElementById('kt-input');
  const phoneInput = document.getElementById('phone-number');
  const ktInput = document.getElementById('kennitala');
  const startBtn = document.getElementById('audkenni-start-btn');
  const cancelBtn = document.getElementById('audkenni-cancel-btn');
  const retryBtn = document.getElementById('audkenni-retry-btn');

  // Views
  const unverifiedView = container.querySelector('.audkenni-unverified');
  const pendingView = container.querySelector('.audkenni-pending');
  const successView = container.querySelector('.audkenni-success');
  const errorView = container.querySelector('.audkenni-error');
  const emailView = container.querySelector('.audkenni-email-view');
  const contextView = container.querySelector('.audkenni-context-view');
  const contextContinueBtn = document.getElementById('audkenni-context-continue-btn');
  const simInstruction = document.getElementById('sim-instruction');
  const appInstruction = document.getElementById('app-instruction');
  const verificationCodeEl = document.getElementById('verification-code');
  const codeDisplay = document.getElementById('code-display');
  const verifiedName = document.getElementById('verified-name');
  const errorMessage = document.getElementById('error-message');

  const customerVerified = container.dataset.customerVerified === 'true';
  const isLoggedIn = customerId !== 'guest';

  function storefrontOrigin() {
    var url = window.__AUDKENNI_STOREFRONT_URL__;
    if (url) return String(url).replace(/\/$/, '');
    return window.location.origin;
  }

  function absoluteStorefrontUrl(pathOrUrl) {
    if (!pathOrUrl) return storefrontOrigin() + '/checkout';
    if (pathOrUrl.indexOf('http') === 0) return pathOrUrl;
    var base = storefrontOrigin();
    return base + (pathOrUrl.indexOf('/') === 0 ? '' : '/') + pathOrUrl;
  }

  function canAutoRedirect() {
    try {
      var now = Date.now();
      var last = parseInt(sessionStorage.getItem('audkenni_redirect_guard_ts'), 10);
      if (last && now - last < 5000) return false;
      sessionStorage.setItem('audkenni_redirect_guard_ts', String(now));
      return true;
    } catch (e) {
      return true;
    }
  }

  function defaultCheckoutUrl() {
    return absoluteStorefrontUrl('/checkout');
  }

  function publishCartState() {
    var verifiedNow =
      customerVerified ||
      !!container.querySelector('.audkenni-verified') ||
      container.getAttribute('data-verified-session') === 'true';
    window.__AUDKENNI_STATE__ = {
      loggedIn: isLoggedIn,
      verified: verifiedNow,
      requireCheckout: requireCheckout,
      loginMode: loginMode,
    };
    document.dispatchEvent(
      new CustomEvent('audkenni-state-ready', { detail: window.__AUDKENNI_STATE__ })
    );
    return verifiedNow;
  }

  function signalVerified() {
    container.setAttribute('data-verified-session', 'true');
    publishCartState();
    document.dispatchEvent(new CustomEvent('audkenni-verified'));
  }

  function checkoutLoginUrl() {
    if (
      accountLoginUrl.indexOf('http') === 0 ||
      accountLoginUrl.indexOf('return_url=') !== -1 ||
      accountLoginUrl.indexOf('return_to=') !== -1 ||
      accountLoginUrl.indexOf('customer_authentication') !== -1
    ) {
      return accountLoginUrl;
    }
    var root =
      typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    if (root.indexOf('/') !== 0) root = '/' + root;
    var checkoutPath = root + (root.endsWith('/') ? '' : '/') + 'checkout';
    if (checkoutPath.indexOf('//') === 0) checkoutPath = checkoutPath.replace(/^\/+/, '/');
    return accountLoginUrl + '?checkout_url=' + encodeURIComponent(checkoutPath);
  }

  function wantsCheckout() {
    if (requireCheckout) return true;
    var path = (window.location.pathname || '').replace(/\/$/, '');
    if (/\/pages\/innskraning$/i.test(path)) return true;
    var params = new URLSearchParams(window.location.search);
    if (params.get('checkout') === '1') return true;
    if ((params.get('return_to') || '').indexOf('checkout') !== -1) return true;
    try {
      if (sessionStorage.getItem('audkenni_redirect_checkout') === '1') return true;
      if (sessionStorage.getItem('audkenni_checkout_url')) return true;
    } catch (e) {}
    return false;
  }

  function ensureCheckoutEmailOnCart() {
    var email = window.__AUDKENNI_CUSTOMER_EMAIL__;
    if (!email) return;
    var form = document.getElementById('cart') || document.querySelector('form[action*="/cart"]');
    if (!form) return;
    var input = form.querySelector('input[name="checkout[email]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout[email]';
      form.appendChild(input);
    }
    input.value = email;
  }

  /** Submit cart form as logged-in checkout — preserves Shopify customer session (vs direct /checkout). */
  function submitCartCheckout() {
    ensureCheckoutEmailOnCart();
    var form = document.getElementById('cart') || document.querySelector('form[action*="/cart"]');
    if (!form) return false;
    if (!form.querySelector('input[name="checkout"]')) {
      var checkoutFlag = document.createElement('input');
      checkoutFlag.type = 'hidden';
      checkoutFlag.name = 'checkout';
      checkoutFlag.value = '';
      form.appendChild(checkoutFlag);
    }
    form.submit();
    return true;
  }

  function goToCheckout() {
    if (!canAutoRedirect()) return;
    try {
      sessionStorage.removeItem('audkenni_redirect_checkout');
      sessionStorage.removeItem('audkenni_checkout_url');
    } catch (e) {}
    if (submitCartCheckout()) return;
    var path = (window.location.pathname || '').replace(/\/$/, '');
    if (!/\/cart$/i.test(path)) {
      window.location.assign(absoluteStorefrontUrl('/cart?checkout=1'));
      return;
    }
    window.location.assign(defaultCheckoutUrl());
  }

  // Initialize
  function init() {
    var checkoutIntent = wantsCheckout();
    var alreadyVerified = publishCartState();

    if (alreadyVerified) {
      signalVerified();
    }

    if (loginMode === 'oidc' && !isLoggedIn && !isInvitationFlow() && !embedAccountLogin) {
      if (!canAutoRedirect()) return;
      window.location.replace(checkoutIntent ? checkoutLoginUrl() : accountLoginUrl);
      return;
    }

    if (getInvitationToken()) {
      validateInvitationTokenIfPresent().then(function(valid) {
        if (!valid) {
          var inviteReadyEl = container.querySelector('.audkenni-invite-ready');
          if (inviteReadyEl) inviteReadyEl.style.display = 'none';
        }
      });
    }

    var acceptInviteBtn = document.getElementById('audkenni-accept-invite-btn');
    if (setupInvitationAcceptFlow()) {
      return;
    }

    methodInputs.forEach(input => {
      input.addEventListener('change', handleMethodChange);
    });

    if (startBtn) {
      startBtn.addEventListener('click', handleStart);
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', handleCancel);
    }

    if (retryBtn) {
      retryBtn.addEventListener('click', handleRetry);
    }

    if (contextContinueBtn) {
      contextContinueBtn.addEventListener('click', handleContextContinue);
    }

    container.addEventListener('click', function (e) {
      if (e.target.closest('#audkenni-email-btn') || e.target.closest('#audkenni-complete-registration-btn')) {
        e.preventDefault();
        handleCompleteRegistration();
      }
    });

    if (phoneInput) {
      phoneInput.addEventListener('input', formatPhoneNumber);
    }
    if (ktInput) {
      ktInput.addEventListener('input', formatKennitala);
    }

    var checkoutParam = new URLSearchParams(window.location.search).get('checkout');
    if (alreadyVerified && checkoutParam === '1' && canAutoRedirect()) {
      submitCartCheckout();
    }

    if (getInvitationToken()) {
      window.requestAnimationFrame(function() { setupInvitationAcceptFlow(); });
      setTimeout(setupInvitationAcceptFlow, 800);
    }
  }

  function applyInvitationOrgName(orgName) {
    if (!orgName) return;
    var desc = container.querySelector('.audkenni-unverified > .audkenni-description');
    if (desc) {
      desc.textContent =
        'Þú hefur fengið boð í ' + orgName + '. Staðfestu auðkenni þitt til að ganga í fyrirtækið.';
    }
    var heading = container.querySelector('.audkenni-unverified .audkenni-heading');
    if (heading) {
      heading.textContent = 'Ganga í ' + orgName;
    }
  }

  function validateInvitationTokenIfPresent() {
    var token = getInvitationToken();
    if (!token) return Promise.resolve(true);
    return fetch(
      API_BASE + '/api/org/invitation/validate?token=' + encodeURIComponent(token) +
      '&shop=' + encodeURIComponent(shop)
    )
      .then(function(r) {
        return r.json().then(function(data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function(result) {
        if (result.data && result.data.valid) {
          applyInvitationOrgName(result.data.orgName || '');
          return true;
        }
        ensureInvitationOutcomeViews();
        showError((result.data && result.data.error) || 'Ógildur hlekkur.', 'invite_invalid');
        return false;
      })
      .catch(function() {
        ensureInvitationOutcomeViews();
        showError('Ógildur hlekkur.', 'invite_invalid');
        return false;
      });
  }

  function handleMethodChange(e) {
    const method = e.target.value;
    if (method === 'sim') {
      simInputGroup.style.display = 'block';
      ktInputGroup.style.display = 'none';
    } else {
      simInputGroup.style.display = 'none';
      ktInputGroup.style.display = 'block';
    }
  }

  function formatPhoneNumber(e) {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 7) value = value.slice(0, 7);
    e.target.value = value;
  }

  function formatKennitala(e) {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 10) value = value.slice(0, 10);
    if (value.length > 6) {
      value = value.slice(0, 6) + '-' + value.slice(6);
    }
    e.target.value = value;
  }

  function getSelectedMethod() {
    const selected = container.querySelector('input[name="auth-method"]:checked');
    return selected ? selected.value : 'sim';
  }

  function getIdentifier() {
    const method = getSelectedMethod();
    if (method === 'sim') {
      return phoneInput.value.replace(/\D/g, '');
    } else {
      return ktInput.value.replace(/\D/g, '');
    }
  }

  function getChosenContext() {
    const selected = container.querySelector('input[name="shopping-context"]:checked');
    if (selected && (selected.value === 'organization' || selected.value === 'personal')) {
      return selected.value;
    }
    const fallback = container.dataset.chosenContext;
    return fallback === 'organization' ? 'organization' : 'personal';
  }

  function validateInput() {
    const method = getSelectedMethod();
    const identifier = getIdentifier();

    if (method === 'sim') {
      if (!/^[4-9]\d{6}$/.test(identifier)) {
        showError('Ógilt símanúmer');
        return false;
      }
    } else {
      if (!/^\d{10}$/.test(identifier)) {
        showError('Ógild kennitala');
        return false;
      }
      if (!validateKennitala(identifier)) {
        showError('Ógild kennitala (vartala stemmir ekki)');
        return false;
      }
    }

    return true;
  }

  function validateKennitala(kt) {
    const weights = [3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 8; i++) {
      sum += parseInt(kt[i]) * weights[i];
    }
    const checkDigit = (11 - (sum % 11)) % 11;
    return checkDigit === parseInt(kt[8]);
  }

  function showView(view) {
    [unverifiedView, pendingView, successView, errorView, emailView, contextView].forEach(v => {
      if (v) v.style.display = 'none';
    });
    if (view) view.style.display = 'block';
  }

  function getErrorMessage(errorCode, fallback) {
    const errors = locale.errors || {};
    return (errorCode && errors[errorCode]) || fallback || (errors.failed || 'Auðkenning mistókst');
  }

  function showError(message, errorCode) {
    var displayMsg = getErrorMessage(errorCode, message);
    if (errorMessage) errorMessage.textContent = displayMsg;
    showView(errorView);
    stopPolling();
    updateErrorViewButtons();
  }

  function showVerificationUnavailable(message, errorCode) {
    var displayMsg = getErrorMessage(errorCode, message);
    if (errorMessage) errorMessage.textContent = displayMsg;
    showView(errorView);
    stopPolling();
    if (!errorView) return;
    var btnContainer = errorView.querySelector('.audkenni-error-actions') || errorView;
    var existingProceed = errorView.querySelector('.audkenni-proceed-without-verify');
    if (existingProceed) existingProceed.remove();
    var proceedBtn = document.createElement('button');
    proceedBtn.type = 'button';
    proceedBtn.className = 'audkenni-btn audkenni-btn-primary audkenni-proceed-without-verify';
    proceedBtn.textContent = locale.proceed_without_verify || 'Halda áfram í greiðslu';
    proceedBtn.addEventListener('click', function() {
      proceedBtn.disabled = true;
      proceedBtn.textContent = 'Hleður...';
      patchCartAttributes({ audkenni_skipped: '1' }).then(function() {
        if (!submitCartCheckout()) {
          var checkoutPath = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'checkout' : '/checkout';
          if (checkoutPath.indexOf('/') !== 0) checkoutPath = '/' + checkoutPath;
          window.location.assign(checkoutPath);
        }
      }).catch(function() {
        proceedBtn.disabled = false;
        proceedBtn.textContent = locale.proceed_without_verify || 'Halda áfram í greiðslu';
      });
    });
    btnContainer.appendChild(proceedBtn);
  }

  function updateErrorViewButtons() {
    if (!errorView) return;
    var existingLater = errorView.querySelector('.audkenni-verify-later');
    var existingSupport = errorView.querySelector('.audkenni-support-link');
    if (existingLater) existingLater.remove();
    if (existingSupport) existingSupport.remove();
    var btnContainer = errorView.querySelector('.audkenni-error-actions') || errorView;
    if (!requireCheckout && retryBtn) {
      var laterBtn = document.createElement('button');
      laterBtn.type = 'button';
      laterBtn.className = 'audkenni-btn audkenni-btn-secondary audkenni-verify-later';
      laterBtn.textContent = locale.verify_later || 'Verify later';
      laterBtn.addEventListener('click', function() {
        showView(unverifiedView);
        errorRetryCount = 0;
      });
      btnContainer.insertBefore(laterBtn, retryBtn);
    }
    if (errorRetryCount >= 2 && supportUrl) {
      var supportLink = document.createElement('a');
      supportLink.href = supportUrl;
      supportLink.className = 'audkenni-support-link';
      supportLink.target = '_blank';
      supportLink.rel = 'noopener';
      supportLink.style.display = 'block';
      supportLink.style.marginTop = '0.75rem';
      supportLink.style.color = '#3b82f6';
      supportLink.textContent = locale.contact_support || 'Contact support';
      errorView.appendChild(supportLink);
    }
  }

  function cartRoot() {
    var root = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    if (root.indexOf('/') !== 0) root = '/' + root;
    return root;
  }

  /** cart/update.js replaces ALL attributes — always merge with cart.js first. */
  function patchCartAttributes(patch) {
    var root = cartRoot();
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(cart) {
        var next = Object.assign({}, (cart && cart.attributes) || {}, patch || {});
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: next })
        });
      });
  }

  function mergeDkCartAttrs(attrs) {
    var dk = window.__AUDKENNI_DK_CART__;
    if (!dk) return attrs;
    if (dk.customer_type != null) attrs.customer_type = String(dk.customer_type);
    if (dk.kennitala != null) attrs.kennitala = dk.kennitala;
    if (dk.buyer_kennitala != null) attrs.buyer_kennitala = dk.buyer_kennitala;
    if (dk.company_kennitala != null) attrs.company_kennitala = dk.company_kennitala;
    return attrs;
  }

  function setCartVerifiedAttributes(name, identifier) {
    var attrs = {};
    if (name) {
      var parts = name.trim().split(/\s+/);
      attrs._audkenni_verified_first_name = parts[0] || '';
      attrs._audkenni_verified_last_name = parts.slice(1).join(' ') || '';
      attrs._audkenni_verified_full_name = name.trim();
    }
    if (identifier && /^[4-9]\d{6}$/.test(identifier)) {
      attrs._audkenni_verified_phone = '+354' + identifier;
    }
    mergeDkCartAttrs(attrs);
    if (Object.keys(attrs).length === 0) return;
    patchCartAttributes(attrs).catch(function() {});
  }

  function saveSessionId(id) {
    emailFormSessionId = id;
    try { localStorage.setItem('_ak_session', id); } catch(e) {}
  }

  function getSessionId() {
    if (emailFormSessionId) return emailFormSessionId;
    try { return localStorage.getItem('_ak_session'); } catch(e) { return null; }
  }

  function finishOidcVerification() {
    if (wantsCheckout() || requireCheckout) {
      if (publishCartState()) {
        goToCheckout();
        return;
      }
      setTimeout(function() {
        window.location.reload();
      }, 1500);
      return;
    }
    var target = isLoggedIn ? '/account' : accountLoginUrl;
    setTimeout(function() {
      window.location.href = target;
    }, 1500);
  }

  function getInvitationToken() {
    var fromData = container.dataset.invitationToken;
    if (fromData) return fromData;
    try {
      var fromUrl = new URLSearchParams(window.location.search).get('token');
      if (fromUrl) {
        container.setAttribute('data-invitation-token', fromUrl);
        return fromUrl;
      }
    } catch (e) {}
    return '';
  }

  function isInvitationFlow() {
    return !!getInvitationToken();
  }

  function isAlreadyVerifiedForInvite() {
    if (customerVerified) return true;
    if (container.getAttribute('data-verified-session') === 'true') return true;
    return !!container.querySelector('.audkenni-verified');
  }

  function ensureInvitationOutcomeViews() {
    if (!container.querySelector('.audkenni-success')) {
      var successEl = document.createElement('div');
      successEl.className = 'audkenni-success';
      successEl.style.display = 'none';
      successEl.innerHTML =
        '<svg class="audkenni-icon audkenni-icon-success" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
        '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>' +
        '<p>Boð samþykkt!</p><p class="audkenni-name" id="verified-name"></p>';
      container.appendChild(successEl);
    }
    if (!container.querySelector('.audkenni-error')) {
      var errorEl = document.createElement('div');
      errorEl.className = 'audkenni-error';
      errorEl.style.display = 'none';
      errorEl.innerHTML =
        '<svg class="audkenni-icon audkenni-icon-error" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
        '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>' +
        '<p id="error-message">Villa kom upp</p>' +
        '<div class="audkenni-error-actions" style="display:flex;flex-wrap:wrap;gap:0.5rem;justify-content:center;">' +
        '<button type="button" id="audkenni-retry-btn" class="audkenni-btn audkenni-btn-secondary">Reyna aftur</button></div>';
      container.appendChild(errorEl);
    }
  }

  function setupInvitationAcceptFlow() {
    if (!isInvitationFlow() || !isAlreadyVerifiedForInvite()) return false;
    if (!isLoggedIn) return false;

    ensureInvitationOutcomeViews();

    var acceptInviteBtn = document.getElementById('audkenni-accept-invite-btn');
    if (!acceptInviteBtn) {
      var inviteReady = container.querySelector('.audkenni-invite-ready');
      if (!inviteReady) {
        inviteReady = document.createElement('div');
        inviteReady.className = 'audkenni-invite-ready audkenni-unverified';
        inviteReady.style.padding = '1.5rem 1.25rem';
        inviteReady.innerHTML =
          '<p class="audkenni-description" style="margin-bottom:1rem;">' +
          'Auðkenni þitt er þegar staðfest. Smelltu hér til að ganga í fyrirtækið og ljúka skráningu.' +
          '</p>' +
          '<button type="button" id="audkenni-accept-invite-btn" class="audkenni-btn audkenni-btn-primary">' +
          'Samþykkja boð</button>';
        container.appendChild(inviteReady);
      } else {
        var actionWrap = inviteReady.querySelector('.audkenni-unverified');
        if (actionWrap && !actionWrap.querySelector('#audkenni-accept-invite-btn')) {
          actionWrap.innerHTML =
            '<p class="audkenni-description" style="margin-bottom:1rem;">' +
            'Auðkenni þitt er þegar staðfest. Smelltu hér til að ganga í fyrirtækið og ljúka skráningu.' +
            '</p>' +
            '<button type="button" id="audkenni-accept-invite-btn" class="audkenni-btn audkenni-btn-primary">' +
            'Samþykkja boð</button>';
        }
      }
      acceptInviteBtn = document.getElementById('audkenni-accept-invite-btn');
    }

    if (acceptInviteBtn && acceptInviteBtn.dataset.inviteWired !== '1') {
      acceptInviteBtn.dataset.inviteWired = '1';
      acceptInviteBtn.addEventListener('click', handleAcceptInvite);
    }

    var retry = document.getElementById('audkenni-retry-btn');
    if (retry && retry.dataset.inviteWired !== '1') {
      retry.dataset.inviteWired = '1';
      retry.addEventListener('click', function() {
        [pendingView, successView, errorView, emailView, contextView].forEach(function(v) {
          if (v) v.style.display = 'none';
        });
        var inviteReadyEl = container.querySelector('.audkenni-invite-ready');
        if (inviteReadyEl) inviteReadyEl.style.display = '';
        else setupInvitationAcceptFlow();
      });
    }

    return true;
  }

  function shouldDeferContextStep(data) {
    if (isInvitationFlow() || data.invitationClaimed) return false;
    if (container.dataset.deferContext === 'false') return false;
    if (data.redirectUrl) return false;
    if (data.firstTimeUrl && !isLoggedIn) return false;
    if (data.orgEligibility && !data.orgEligibility.canShopAsOrganization) return false;
    return true;
  }

  function configureContextStep(data) {
    var eligibility = data.orgEligibility;
    var orgLabel = container.querySelector('.audkenni-context-org-label');
    var orgOption = container.querySelector('.audkenni-context-org-option');
    var personalSub = document.getElementById('context-personal-sub');
    var orgSub = document.getElementById('context-org-sub');

    if (personalSub && data.userInfo) {
      var personalParts = [];
      if (data.userInfo.name) personalParts.push(data.userInfo.name);
      if (data.userInfo.kennitala) personalParts.push('Kt. ' + data.userInfo.kennitala);
      personalSub.textContent = personalParts.join(' · ');
    }

    if (!eligibility || !eligibility.canShopAsOrganization) {
      if (orgOption) orgOption.style.display = 'none';
      return;
    }

    var org = eligibility.organizations && eligibility.organizations[0];
    if (orgLabel && org) {
      orgLabel.textContent = 'Fyrirtæki — ' + org.name;
    }
    if (orgSub && org) {
      orgSub.textContent = org.kennitala ? 'Kt. ' + org.kennitala : org.name;
    }
    if (orgOption && org) {
      orgOption.style.display = '';
      orgOption.dataset.organizationId = org.id;
    }
  }

  function extractRegistrationToken(firstTimeUrl) {
    if (!firstTimeUrl) return null;
    try {
      return new URL(firstTimeUrl, storefrontOrigin()).searchParams.get('token');
    } catch (e) {
      var m = String(firstTimeUrl).match(/[?&]token=([^&]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    }
  }

  function showEmailStep(orgName, invitationEmail) {
    var desc = container.querySelector('.audkenni-email-view .audkenni-description');
    if (desc) {
      desc.textContent = orgName
        ? 'Þú ert að ganga í ' + orgName + '. Sláðu inn netfangið þitt til að ljúka skráningu.'
        : 'Sláðu inn netfangið þitt til að ljúka skráningu.';
    }
    var errEl = container.querySelector('#audkenni-email-error');
    if (errEl) errEl.style.display = 'none';
    showView(emailView);
    var input = container.querySelector('#audkenni-email-input');
    if (input && invitationEmail) {
      input.value = invitationEmail;
    }
    if (input) { try { input.focus(); } catch (e) {} }
  }

  function storefrontAccountUrl() {
    return storefrontOrigin() + '/account';
  }

  /** After invite claim for an already-logged-in customer — stay on storefront. */
  function inviteClaimDoneUrl(data) {
    if (isLoggedIn) {
      return storefrontAccountUrl();
    }
    var serverUrl = data && data.storefrontRedirectUrl;
    if (!serverUrl || typeof serverUrl !== 'string') {
      return storefrontAccountUrl();
    }
    if (/customer_authentication|innskraning|adgangur|\/authorize|sso\/handoff/i.test(serverUrl)) {
      return storefrontAccountUrl();
    }
    try {
      var parsed = new URL(serverUrl, storefrontOrigin());
      if (parsed.origin === storefrontOrigin()) {
        return parsed.toString();
      }
    } catch (e) {}
    return storefrontAccountUrl();
  }

  /**
   * Guests who just verified + claimed an invite must go through SSO handoff.
   * Sending them to bare /account strips the handoff and forces a second Auðkenni
   * login (and can loop if return_to bounces them again).
   */
  function inviteRedirectTarget(data) {
    if (data && data.invitationClaimed && isLoggedIn) {
      return storefrontAccountUrl();
    }

    if (!isLoggedIn && data) {
      var handoff =
        data.invitationRedirectUrl ||
        data.redirectUrl ||
        '';
      if (handoff && /sso\/handoff/i.test(String(handoff))) {
        return handoff;
      }
    }

    if (isInvitationFlow() && !isLoggedIn) {
      try {
        var login = new URL(accountLoginUrl, storefrontOrigin());
        login.searchParams.set('return_to', '/account');
        if (data && data.redirectUrl) return data.redirectUrl;
        return login.toString();
      } catch (e) {}
    }
    return inviteClaimDoneUrl(data);
  }

  function proceedAfterVerification(data) {
    if (!data) return;

    if (data.invitationClaimError) {
      showError(data.invitationClaimError, 'invite_claim_failed');
      return;
    }

    // Invite flow for a brand-new customer: collect email inline so registration +
    // company join complete in one step (no separate skráning page / re-click).
    if ((isInvitationFlow() || data.invitationClaimed) && data.firstTimeUrl) {
      var inviteToken = extractRegistrationToken(data.firstTimeUrl);
      if (inviteToken) {
        registrationToken = inviteToken;
        registrationReturnTo = '/account';
        showEmailStep(data.invitationOrgName, data.invitationEmail);
        return;
      }
    }

    if (data.invitationClaimed) {
      var successMsg = container.querySelector('.audkenni-success .audkenni-description, .audkenni-success p');
      if (successMsg && data.invitationOrgName) {
        successMsg.textContent = 'Þú hefur gengið í ' + data.invitationOrgName + '.';
      }
      showView(successView);
      setTimeout(function() {
        var target = inviteRedirectTarget(data);
        // Invitation page may patch location.replace; href still works for SSO handoff.
        if (target && /\/sso\/handoff/i.test(String(target))) {
          window.location.href = target;
        } else {
          window.location.replace(target);
        }
      }, 800);
      return;
    }

    if (data.redirectUrl) {
      window.location.href = data.redirectUrl;
      return;
    }

    if (data.firstTimeUrl) {
      setTimeout(function() {
        window.location.href = data.firstTimeUrl;
      }, 1500);
      return;
    }

    if (loginMode === 'oidc' && (requireCheckout || wantsCheckout()) && !isInvitationFlow()) {
      if (publishCartState()) {
        goToCheckout();
        return;
      }
      setTimeout(function() {
        window.location.reload();
      }, 1500);
      return;
    }

    if (loginMode === 'oidc') {
      finishOidcVerification();
      return;
    }

    setTimeout(function() {
      window.location.href = accountLoginUrl;
    }, 1500);
  }

  function finishVerificationFlow(data) {
    if (shouldDeferContextStep(data)) {
      pendingCompleteData = data;
      var contextNameEl = document.getElementById('context-verified-name');
      if (contextNameEl && data.userInfo && data.userInfo.name) {
        contextNameEl.textContent = data.userInfo.name;
      }
      var orgHint = document.getElementById('context-org-unavailable');
      if (orgHint) orgHint.style.display = 'none';
      configureContextStep(data);
      var personalRadio = container.querySelector(
        '.audkenni-context-view input[name="shopping-context"][value="personal"]'
      );
      if (personalRadio) personalRadio.checked = true;
      showView(contextView);
      return;
    }
    proceedAfterVerification(data);
  }

  async function handleContextContinue() {
    var context = getChosenContext();
    var sessionId = getSessionId();
    var orgOption = container.querySelector('.audkenni-context-org-option');
    var organizationId = orgOption && orgOption.dataset.organizationId ? orgOption.dataset.organizationId : null;
    if (contextContinueBtn) {
      contextContinueBtn.disabled = true;
      contextContinueBtn.textContent = 'Hleður...';
    }
    try {
      if (sessionId) {
        var returnTo = window.location.pathname + window.location.search;
        var payload = { sessionId: sessionId, chosenContext: context, returnTo: returnTo };
        if (context === 'organization' && organizationId) {
          payload.organizationId = organizationId;
        }
        var res = await fetch(API_BASE + '/api/auth/set-context', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        var body = {};
        try { body = await res.json(); } catch (e) {}
        if (!res.ok) {
          var errMsg = body.error || 'Gat ekki stillt samhengi. Reyndu aftur.';
          showError(errMsg, body.code || 'set_context_failed');
          if (contextContinueBtn) {
            contextContinueBtn.disabled = false;
            contextContinueBtn.textContent = 'Halda áfram';
          }
          return;
        }
        if (body.appliedContext === 'personal' && context === 'organization') {
          var orgHint = document.getElementById('context-org-unavailable');
          if (orgHint) orgHint.style.display = 'block';
          if (contextContinueBtn) {
            contextContinueBtn.disabled = false;
            contextContinueBtn.textContent = 'Halda áfram';
          }
          return;
        }
        // Personal: rebuild Customer Accounts session without B2B company context.
        if (body.requiresSessionRefresh) {
          var handoff = body.sessionRefreshUrl;
          var logoutBase =
            (typeof window !== 'undefined' && window.__AUDKENNI_ACCOUNT_LOGOUT_URL__) ||
            '/account/logout';
          if (handoff) {
            try { sessionStorage.setItem('audkenni-sso-handoff', handoff); } catch (e) {}
          }
          try {
            var u = new URL(logoutBase, window.location.origin);
            u.searchParams.set('return_to', '/');
            window.location.href = u.origin !== window.location.origin ? u.toString() : (u.pathname + u.search);
          } catch (e) {
            window.location.href = '/account/logout?return_to=' + encodeURIComponent('/');
          }
          return;
        }
      }
    } catch (e) {
      console.warn('set-context failed', e);
    }
    var data = pendingCompleteData;
    pendingCompleteData = null;
    if (contextContinueBtn) {
      contextContinueBtn.disabled = false;
      contextContinueBtn.textContent = 'Halda áfram';
    }
    proceedAfterVerification(data);
  }

  async function handleAcceptInvite() {
    var btn = document.getElementById('audkenni-accept-invite-btn');
    var token = getInvitationToken();
    if (!btn || !token) return;
    if (!isLoggedIn) {
      showError('Þú þarft að vera skráð(ur) inn til að samþykkja boðið.', 'invite_claim_failed');
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Hleður...';
    try {
      var res = await fetch(API_BASE + '/api/org/invitation/claim', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: token,
          shop: shop,
          customerId: customerId,
        }),
      });
      var data = {};
      try {
        data = await res.json();
      } catch (e) {}
      if (!res.ok) {
        var inviteReadyEl = container.querySelector('.audkenni-invite-ready');
        if (inviteReadyEl) inviteReadyEl.style.display = 'none';
        showError(data.error || 'Ekki tókst að samþykkja boðið', 'invite_claim_failed');
        btn.disabled = false;
        btn.textContent = 'Samþykkja boð';
        return;
      }
      var inviteReady = container.querySelector('.audkenni-invite-ready');
      if (inviteReady) inviteReady.style.display = 'none';
      var successMsg = container.querySelector('.audkenni-success p');
      if (successMsg && data.orgName) {
        successMsg.textContent = 'Þú hefur gengið í ' + data.orgName + '.';
      }
      showView(successView || container.querySelector('.audkenni-success'));
      setTimeout(function() {
        window.location.replace(inviteClaimDoneUrl(data));
      }, 800);
    } catch (e) {
      console.error('invite claim failed', e);
      var inviteReadyErr = container.querySelector('.audkenni-invite-ready');
      if (inviteReadyErr) inviteReadyErr.style.display = 'none';
      showError('Tenging mistókst. Reyndu aftur eftir augnablik.', 'server_error');
      btn.disabled = false;
      btn.textContent = 'Samþykkja boð';
    }
  }

  async function handleStart() {
    if (!validateInput()) return;

    const method = getSelectedMethod();
    const identifier = getIdentifier();

    startBtn.disabled = true;
    startBtn.textContent = 'Hleður...';

    try {
      const response = await fetch(`${API_BASE}/api/auth/start`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shop,
          customerId,
          identifier,
          method,
          chosenContext: getInvitationToken() ? 'organization' : (container.dataset.chosenContext || 'personal'),
          invitationToken: getInvitationToken() || null,
          returnTo: embedAccountLogin ? loginReturnPath : undefined,
        }),
      });

      if (!response.ok) {
        var err = { error: null, errorCode: null, allowProceed: false, errorDetail: null, hint: null };
        try {
          var body = await response.json();
          if (body && typeof body === 'object') {
            err.error = body.error;
            err.errorCode = body.errorCode;
            err.allowProceed = !!body.allowProceed;
            err.errorDetail = body.errorDetail || null;
            err.hint = body.hint || null;
          }
        } catch (e) {
          console.warn('Auth start: could not parse error response', e);
        }
        errorRetryCount++;
        var msg = err.error || 'Staðfesting ekki tiltæk. Reyndu aftur síðar.';
        if (err.errorDetail) msg += ' (' + err.errorDetail + ')';
        if (err.hint) msg += ' ' + err.hint;
        if (err.allowProceed) {
          showVerificationUnavailable(msg, err.errorCode);
        } else {
          showError(msg, err.errorCode);
        }
        return;
      }

      const data = await response.json();
      currentSessionId = data.sessionId;

      showView(pendingView);

      if (method === 'sim') {
        simInstruction.style.display = 'block';
        appInstruction.style.display = 'none';
      } else {
        simInstruction.style.display = 'none';
        appInstruction.style.display = 'block';
      }
      if (data.verificationCode) {
        verificationCodeEl.style.display = 'block';
        codeDisplay.textContent = data.verificationCode;
      }

      startPolling();

    } catch (error) {
      console.error('Start error:', error);
      errorRetryCount++;
      showError(error.message, 'server_error');
    } finally {
      startBtn.disabled = false;
      startBtn.textContent = embedAccountLogin ? 'Skrá inn með Auðkenni' : 'Staðfesta og halda áfram';
    }
  }

  async function poll() {
    if (!currentSessionId) return;

    pollAttempts++;
    if (pollAttempts > MAX_POLL_ATTEMPTS) {
      errorRetryCount++;
      showError('Auðkenning rann út á tíma', 'expired');
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/api/auth/poll`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: currentSessionId }),
      });

      if (!response.ok) {
        const err = await response.json();
        errorRetryCount++;
        showError(err.error || 'Villa við að athuga stöðu', err.errorCode);
        return;
      }

      const data = await response.json();

      switch (data.status) {
        case 'complete':
          saveSessionId(currentSessionId);
          stopPolling();
          if (data.userInfo && data.userInfo.name) {
            verifiedName.textContent = data.userInfo.name;
          }
          if (container) container.setAttribute('data-verified-session', 'true');
          if (data.userInfo && data.userInfo.kennitala) {
            var pollKt = String(data.userInfo.kennitala).replace(/\D/g, '');
            if (pollKt.length === 10) {
              var dk = window.__AUDKENNI_DK_CART__ || {
                customer_type: '0',
                kennitala: pollKt,
                buyer_kennitala: pollKt,
                company_kennitala: ''
              };
              dk.buyer_kennitala = pollKt;
              if (dk.customer_type !== '1') dk.kennitala = pollKt;
              window.__AUDKENNI_DK_CART__ = dk;
            }
          }
          setCartVerifiedAttributes(data.userInfo && data.userInfo.name ? data.userInfo.name : '', getIdentifier());
          signalVerified();
          finishVerificationFlow(data);
          break;

        case 'failed':
          stopPolling();
          errorRetryCount++;
          showError(data.error || 'Auðkenning mistókst', data.errorCode);
          break;

        case 'expired':
          stopPolling();
          errorRetryCount++;
          showError('Auðkenning rann út á tíma', data.errorCode || 'expired');
          break;

        case 'pending':
          break;

        default:
          console.warn('Unknown status:', data.status);
      }

    } catch (error) {
      console.error('Poll error:', error);
      if (pollAttempts > 3 && error.message.includes('fetch')) {
        errorRetryCount++;
        showError('Tenging rofnaði. Reyndu aftur.', 'server_error');
      }
    }
  }

  function startPolling() {
    pollAttempts = 0;
    if (pollInterval) clearInterval(pollInterval);
    pollInterval = setInterval(poll, POLL_INTERVAL);
    poll();
  }

  function stopPolling() {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
    currentSessionId = null;
    pollAttempts = 0;
  }

  function handleCancel() {
    stopPolling();
    showView(unverifiedView);
  }

  function handleRetry() {
    showView(unverifiedView);
  }

  async function handleCompleteRegistration() {
    var emailErrEl = container.querySelector('#audkenni-email-error');
    var input = container.querySelector('#audkenni-email-input');
    var btn = container.querySelector('#audkenni-complete-registration-btn');
    var email = (input && input.value ? input.value : '').trim();

    function showEmailError(msg) {
      if (emailErrEl) {
        emailErrEl.textContent = msg;
        emailErrEl.style.display = 'block';
      }
    }
    if (emailErrEl) emailErrEl.style.display = 'none';

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      showEmailError('Sláðu inn gilt netfang.');
      return;
    }
    if (!registrationToken) {
      showEmailError('Notaðu skráningarsíðuna (/pages/skraning) eða skráðu þig inn með Auðkenni.');
      return;
    }

    if (btn) { btn.disabled = true; btn.textContent = 'Hleður...'; }
    try {
      var res = await fetch(API_BASE + '/api/auth/complete-registration', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shop: shop,
          token: registrationToken,
          email: email,
          returnTo: registrationReturnTo || '/account',
          loggedIn: !!isLoggedIn,
        }),
      });
      var body = {};
      try { body = await res.json(); } catch (e) {}
      if (res.ok && body && body.success) {
        var target = body.redirectUrl || (isLoggedIn ? '/account' : accountLoginUrl);
        window.location.href = target;
        return;
      }
      showEmailError((body && body.error) || 'Ekki tókst að ljúka skráningu. Reyndu aftur.');
    } catch (e) {
      console.error('complete-registration failed', e);
      showEmailError('Villa við skráningu. Reyndu aftur.');
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = 'Ljúka skráningu'; }
    }
  }

  document.addEventListener('audkenni-invitation-ready', function() {
    setupInvitationAcceptFlow();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();